<template>
    <div v-if="store.loadingApp" class="loading"></div>
    <v-app v-else>
        <Header :additionalClass="additionalClass"/>
        <main>
            <router-view v-slot="{ Component, route }">
                <transition name="fade">
                    <component :is="Component" :key="route.path" />
                </transition>
            </router-view>
        </main>
        <Footer :additionalClass="additionalClass"/>
    </v-app>
    <component
        v-model="store.alert.visible"
        :is="Alert"
        :type="store.alert.type"
        :title="store.alert.title"
        :closable="store.alert.closable"
        :message="store.alert.message"
    />
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from "@/js/stores/index";
import { useRoute } from 'vue-router';
import Header from "@/js/components/common/Header.vue";
import Footer from "@/js/components/common/Footer.vue";
import Alert from "@/js/components/common/Alert.vue";

const store = useStore();
const route = useRoute();
const loading = ref(false);

const additionalClass = computed(() => {
    return route.meta.header ? '' : 'is-hidden';
});

store.getInitData();

</script>
